import { Link } from "react-router-dom";
import { mediaList, typeLabel } from "@/mocks/media";

const hotItems = [...mediaList].sort((a, b) => b.views - a.views).slice(0, 10);

export default function HotSidebar() {
  return (
    <aside className="w-full lg:w-[300px] shrink-0 space-y-4">
      <section
        aria-label="热门推荐"
        className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
      >
        <div className="flex items-center justify-between px-4 h-12 border-b border-background-200 bg-background-100">
          <h2 className="font-heading text-[15px] font-semibold text-foreground-950 flex items-center gap-2">
            <i className="ri-fire-line text-accent-500 text-base"></i>
            热门推荐
          </h2>
          <span className="text-[11px] text-foreground-500">按播放量</span>
        </div>
        <ol className="divide-y divide-background-200">
          {hotItems.slice(0, 7).map((item, index) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="flex items-center gap-3 px-3 py-2.5 hover:bg-background-100 transition-colors group">
                <span
                  className={`w-5 text-center text-sm font-heading font-bold shrink-0 ${
                    index < 3 ? "text-accent-600" : "text-foreground-300"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="w-11 h-14 shrink-0 rounded overflow-hidden bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} 缩略图`}
                    title={`${item.title} ${typeLabel[item.type]}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-[13px] font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </p>
                  <p className="text-[11px] text-foreground-500 mt-1 truncate">
                    {typeLabel[item.type]} · {item.genres[0]}
                  </p>
                  <p className="text-[11px] text-foreground-400 mt-0.5">
                    {(item.views / 10000).toFixed(0)}万次浏览
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section aria-label="分类快捷入口" className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="font-heading text-[15px] font-semibold text-foreground-950 mb-3 flex items-center gap-2">
          <i className="ri-apps-line text-primary-500 text-base"></i>
          浏览频道
        </h2>
        <div className="grid grid-cols-3 gap-2">
          {[
            { key: "movie", label: "电影", icon: "ri-film-line" },
            { key: "tv", label: "剧集", icon: "ri-tv-2-line" },
            { key: "variety", label: "综艺", icon: "ri-mic-line" },
          ].map((item) => (
            <Link
              key={item.key}
              to={`/category/${item.key}`}
              className="flex flex-col items-center justify-center gap-1.5 py-3 rounded-md bg-background-100 hover:bg-secondary-100 transition-colors"
            >
              <i className={`${item.icon} text-lg text-primary-600`}></i>
              <span className="text-xs text-foreground-700">{item.label}</span>
            </Link>
          ))}
        </div>
        <div className="mt-3 pt-3 border-t border-background-200">
          <p className="text-[11px] leading-5 text-foreground-500">
            想看什么可以先去
            <Link to="/search" className="text-primary-600 hover:underline mx-1">
              搜索页
            </Link>
            试试关键词，比如“悬疑”“治愈”。
          </p>
        </div>
      </section>

      <section aria-label="站内数据" className="rounded-lg bg-primary-900 p-4 text-background-100">
        <h2 className="font-heading text-[15px] font-semibold text-background-50 mb-3">站内速览</h2>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <p className="font-heading text-xl font-bold text-secondary-400">{mediaList.length}</p>
            <p className="text-[11px] text-background-300 mt-0.5">部影视作品</p>
          </div>
          <div>
            <p className="font-heading text-xl font-bold text-secondary-400">3</p>
            <p className="text-[11px] text-background-300 mt-0.5">个主频道</p>
          </div>
          <div>
            <p className="font-heading text-xl font-bold text-secondary-400">48</p>
            <p className="text-[11px] text-background-300 mt-0.5">个类型标签</p>
          </div>
          <div>
            <p className="font-heading text-xl font-bold text-secondary-400">每日</p>
            <p className="text-[11px] text-background-300 mt-0.5">更新展示</p>
          </div>
        </div>
        <p className="text-[11px] text-background-400 mt-3">本站为示例演示站点，内容均为虚构。</p>
      </section>
    </aside>
  );
}